import React, { useState, useEffect } from 'react';
import { Terminal, Image } from 'lucide-react';

interface LogEntry {
  timestamp: number;
  message: string;
  type: 'info' | 'error' | 'warn' | 'image';
}

const MAX_LOGS = 50;
let logs: LogEntry[] = [];

export function log(message: string, type: 'info' | 'error' | 'warn' | 'image' = 'info') {
  logs = [{
    timestamp: Date.now(),
    message,
    type
  }, ...logs].slice(0, MAX_LOGS);
}

export default function DebugLogger() {
  const [isVisible, setIsVisible] = useState(false);
  const [entries, setEntries] = useState<LogEntry[]>([]);

  useEffect(() => {
    const interval = setInterval(() => {
      setEntries([...logs]);
    }, 100);

    return () => clearInterval(interval);
  }, []);

  if (!isVisible) {
    return (
      <button
        onClick={() => setIsVisible(true)}
        className="fixed bottom-4 right-4 z-50 p-2 bg-black/80 rounded-full shadow-lg"
      >
        <Terminal className="w-6 h-6 text-white" />
      </button>
    );
  }

  return (
    <div className="fixed inset-0 z-50 bg-black/95 p-4 overflow-auto">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-white font-mono text-sm">Debug Log</h2>
        <button
          onClick={() => setIsVisible(false)}
          className="text-white/60 hover:text-white"
        >
          Close
        </button>
      </div>
      <div className="space-y-2">
        {entries.map((entry, index) => (
          <div
            key={entry.timestamp + index}
            className={`font-mono text-xs ${
              entry.type === 'error' ? 'text-red-400' : 
              entry.type === 'warn' ? 'text-yellow-400' : 
              entry.type === 'image' ? 'text-blue-400' :
              'text-green-400' 
            }`}
          >
            {entry.type === 'image' && <Image size={12} className="inline-block mr-2" />}
            [{new Date(entry.timestamp).toLocaleTimeString()}] {entry.message}
          </div>
        ))}
      </div>
    </div>
  );
}